import { useRef, useEffect } from 'react';

/**
 * Checks whether or not the component is mounted.
 * @returns {Boolean}
 */
const useDidMount = () => {
    const isMountRef = useRef(false);

    useEffect(() => {
        isMountRef.current = true;
    }, []);

    return isMountRef.current;
};

export default useDidMount;
